export const redirectToLogin = (navigate: any) => {
    navigate('/');
}